// AI Skill Platform — Agent Chat types

export type ConversationStatus = 'active' | 'completed' | 'cancelled';

export interface AgentConversation {
  id: number;
  user_id: number;
  status: ConversationStatus;
  current_provider: string | null;
  pending_confirmation: Record<string, unknown> | string | null;
  metadata_json: Record<string, unknown> | null;
  total_messages: number;
  created_at: string;
  updated_at: string;
  messages?: AgentMessage[];
}

export interface AgentConversationListItem {
  id: number;
  status: ConversationStatus;
  current_provider: string | null;
  has_pending_confirmation: boolean;
  created_at: string;
  updated_at: string;
}

export interface AgentToolCall {
  name: string;
  input: Record<string, unknown>;
}

export interface AgentToolResult {
  success: boolean;
  data: unknown;
}

export interface AgentMessage {
  id: number;
  conversation_id: number;
  role: 'user' | 'assistant' | 'confirmation';
  content: string | null;
  tool_calls: (AgentToolCall & { tool_name?: string })[] | null;
  tool_results: AgentToolResult[] | null;
  tokens_used: number;
  model_used: string | null;
  created_at: string;
}

export interface SendMessageResponse {
  user_message: AgentMessage;
  assistant_message: AgentMessage;
  requires_confirmation: boolean;
  confirmation_preview: string | null;
}

export interface ConfirmActionResponse {
  success: boolean;
  message: string;
  tool_name: string;
  result: Record<string, unknown> | null;
}

export interface CancelActionResponse {
  success: boolean;
  message: string;
  tool_name: string;
  result: null;
}

export interface AgentConversationListResponse {
  items: AgentConversationListItem[];
  total: number;
}

/** Provider display mapping */
export const PROVIDER_LABELS: Record<string, { icon: string; label: string }> = {
  b2b_integration: { icon: 'Plug', label: 'B2B Integration' },
  entity_builder: { icon: 'Blocks', label: 'Entity Builder' },
  payment_schedule: { icon: 'CreditCard', label: 'Графики платежей' },
};
